import React from "react";
import { Tabs } from "material-ui/Tabs";
import TabsNew from "@techsoftware/happay-widgets/Tabs";

export default class CustomTabs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    onTabChange = (e, value) => {
        this.props.onChange(value);
    };
    render() {
        if (this.props.isWidgetComp) {
            return (
                <TabsNew
                    {...this.props}
                    activeIndex={this.props.value} // in Widgets, activeIndex props should be a number, but here we are assigning string
                    onTabChange={this.onTabChange}
                    isSmallView
                    noBorder
                />
            );
        }
        return (
            <Tabs
                {...this.props}
                //borderBottom: '1px solid #e0e0e0'
                inkBarStyle={Object.assign(
                    { background: "#1D7CBF", height: 3 },
                    this.props.inkBarStyle
                )}
                className={"custom-tab"}
                style={Object.assign(
                    {
                        backgroundColor: "#ffffff",
                        color: "#54698d",
                        fontSize: "12px",
                        fontWeight: 400
                    },
                    this.props.style
                )}
            />
        );
    }
}
